import React from "react";
import { Box, Text } from "@salestrak/ui";
import { PRIVACY_URL, TERMS_URL } from "#app/lib/marketing-urls";

// Inline legal links: real anchors inside the sentence flow, so the browser
// owns middle-click/copy-link and no click handler is needed.
export function LegalLinks() {
  return (
    <Box align="center" paddingX="lg" paddingY="md">
      <Text size="xs" weight="medium" variant="muted" align="center">
        By continuing, you agree to SalesTrak's{" "}
        <Text
          as="a"
          href={TERMS_URL}
          target="_blank"
          rel="noopener noreferrer"
          size="xs"
          variant="link"
        >
          Terms of Service
        </Text>{" "}
        and{" "}
        <Text
          as="a"
          href={PRIVACY_URL}
          target="_blank"
          rel="noopener noreferrer"
          size="xs"
          variant="link"
        >
          Privacy Policy
        </Text>
        .
      </Text>
    </Box>
  );
}
